import { useMutation, UseMutationOptions } from "@tanstack/react-query";

import { authClient, betterAuthErrorText } from "lib/auth/authClient";

type DisableTwoFactorData = { status: boolean };

/**
 * Disables TOTP for the current user. Requires the password as a re-authentication step.
 * @param options
 * @returns
 */
export function useDisableTwoFactor(
  options?: UseMutationOptions<DisableTwoFactorData, unknown, { password: string }, unknown>,
) {
  return useMutation({
    mutationFn: async ({ password }: { password: string }): Promise<DisableTwoFactorData> => {
      const { data, error } = await authClient.twoFactor.disable({ password });
      if (error) {
        throw new Error(betterAuthErrorText(error, "Could not disable two-factor"));
      }
      return data;
    },
    ...options,
  });
}
